import {flipwitFirebaseConnector} from '../flipwitFirebaseConnector'
import { platformHandler } from '../PlatformHandler'

let osHandler = {};

/*module.exports = function WebHandler() {

  return osHandler;
}*/

osHandler.init = function(){
  
}

osHandler.signInWithEmailAndPassword = function(data) {
	return flipwitFirebaseConnector.signInWithEmailAndPassword(data);
}
osHandler.fetchSignInMethodsForEmail = data => {
    return flipwitFirebaseConnector.fetchSignInMethodsForEmail(data);
}


osHandler.signInGoogle = function() {
	flipwitFirebaseConnector.signInGoogleProvider( );
}

osHandler.executeCommand = function( command ){
  platformHandler.getDataConnector().sendCommand( command ); 
}

osHandler.getPptsOpen = function( ){
  platformHandler.getDataConnector().getPPTsOpen();
}

osHandler.toggleFullScreen = function( value ){

}

osHandler.openExternalURL = (url) => {
	window.open(url);
}

export default function WebHandler() {
	console.log('Si pasa por acá')
  return osHandler;
}


// WEBPACK FOOTER //
// ./src/containers/platforms/web/WebHandler.js